import { render, staticRenderFns } from "./serviceItem.vue?vue&type=template&id=7882317f&scoped=true&lang=html&"
import script from "./serviceItem.vue?vue&type=script&lang=js&"
export * from "./serviceItem.vue?vue&type=script&lang=js&"
import style0 from "./serviceItem.vue?vue&type=style&index=0&id=7882317f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7882317f",
  null
  
)

export default component.exports